// SSR stub for shiki — outputs plain <pre><code> with escaped HTML
function escapeHtml(str: string): string {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}

export async function codeToHtml(code: string, opts: any = {}): Promise<string> {
  const lang = opts?.lang || opts?.language || 'text'
  return `<pre class="shiki" data-language="${lang}"><code class="language-${lang}">${escapeHtml(code)}</code></pre>`
}

export const bundledLanguages: Record<string, unknown> = {}
export const bundledThemes: Record<string, unknown> = {}
export const bundledLanguagesInfo: any[] = []
export const bundledThemesInfo: any[] = []

export async function createHighlighter() {
  return { codeToHtml, loadLanguage: () => {}, loadTheme: () => {}, getLoadedLanguages: () => [], getLoadedThemes: () => [] }
}
export const getHighlighter = createHighlighter
export const getSingletonHighlighter = createHighlighter
export function normalizeTheme(theme: any) { return theme }
export function createJavaScriptRegexEngine() { return {} }
